<template>
  <v-main id="loginContainer" class="primary">
    <v-container
      class="fill-height"
      fluid
    >
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
          sm="8"
          md="4"
        >
         <!-- Card Usuário Licenças -->
          <v-card elevation="12" v-if="usuario_licencas.length">
            <v-toolbar flat>
              <v-toolbar-title class="d-flex align-center font-weight-bold">
                <img src="@/assets/logo.png" class="mr-3" alt="Syclus">
                Selecione a Licença
              </v-toolbar-title>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="py-0">
              <ListItemSelect
                v-for="licenca of usuario_licencas"
                :key="licenca._id"
                :title="licenca.titulo"
                @itemClicked="selectLicence(licenca.id_licenca)"
              />
            </v-card-text>
          </v-card>
          <!-- Card LOGIN -->
          <v-card elevation="12" v-else>
            <v-toolbar flat>
              <v-toolbar-title class="d-flex align-center font-weight-bold">
                <img src="@/assets/logo.png" class="mr-3" alt="Syclus">
                Syclus Pedidos
              </v-toolbar-title>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text>
              <p>Informe seu login fornecido pela Syclus</p>
              <v-form
                v-model="valid"
                ref="loginForm"
                lazy-validation
                @submit.prevent="handleLogin"
              >
                <v-text-field
                  v-model="email"
                  label="E-mail"
                  name="login"
                  prepend-inner-icon="mdi-account"
                  type="email"
                  outlined
                  spellcheck="false"
                  :rules="[rules.required, rules.email]"
                  required
                ></v-text-field>

                <v-text-field
                  v-model="password"
                  id="password"
                  label="Senha"
                  name="password"
                  prepend-inner-icon="mdi-lock"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showPassword = !showPassword"
                  :type="showPassword ? 'text' : 'password'"
                  outlined
                  :rules="[rules.required]"
                  required
                ></v-text-field>
                <v-btn
                  type="submit"
                  color="primary"
                  block
                  :loading="loading"
                  :disabled="!valid"
                >Entrar</v-btn>
              </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text class="card-actions-text">
              <div class="text-center body-2">
                Não tem um login? <a href="tel:+558233110632">(82) 3311-0632</a>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import ListItemSelect from '@/components/shared/list/ListItemSelect';

  export default {
    props: {
      source: String,
    },
    components: {
      ListItemSelect
    },
    data: () => ({
      valid: true,
      showPassword: false,
      email: '',
      password: ''
    }),
    computed: {
      ...mapGetters(['rules', 'loading', 'usuario_licencas', 'apiHost']),
    },
    methods: {
      ...mapActions(['login']),
      async handleLogin() {
        if (this.$refs.loginForm.validate()) {
          const response = await this.login({ email: this.email, senha: this.password });
          this.handleLoginResponse(response);
        }
      },
      handleLoginResponse(response) {
        if (response && this.apiHost) {
          this.$router.push({ name: 'Home' });
        } else if (response && !this.apiHost) {
          this.$router.push({ name: 'Configuracoes', query: { backup: true } });
        }
      },
      async selectLicence(id_licenca) {
        const response = await this.login({ email: this.email, senha: this.password, id_licenca });
        this.handleLoginResponse(response);
      }
    }
  }
</script>

<style scoped>
#loginContainer {
  width: 100vw;
  height: 100vh;
}

.card-actions-text a {
  text-decoration: none;
  font-weight: bold;
}
</style>